module.exports = __webpack_public_path__ + "img/ug314.c375a381.png";